import type { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';

import { ErrorSubdomain } from '../../../constants';

import { ServerSideError } from './server-side-error';

export class InternalServerError extends ServerSideError {
  constructor(message: string) {
    super(message, 'Internal Server Error');
  }

  public getServerSidePropsResult(
    context: GetServerSidePropsContext
  ): GetServerSidePropsResult<any> {
    return this.getRedirectServerSidePropsResult(
      context,
      ErrorSubdomain.InternalServerErrorSubdomain
    );
  }
}
